import { MarketEnum } from '@/config/tenants/types'
import { SiteContextBasedIdEnum } from '@/enums/SiteContextBasedIdEnum'
import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { isB2B } from '@/helpers/isB2B'

export const getMarketSAP = (
  tenantId: string,
  siteContext: SiteContextModeEnum = SiteContextModeEnum.b2b
): SiteContextBasedIdEnum => {
  switch (tenantId) {
    case MarketEnum.mediq_dk:
      return isB2B(siteContext) ? SiteContextBasedIdEnum['dk-b2b'] : SiteContextBasedIdEnum['dk-b2c']
    case MarketEnum.mediq_no:
      return SiteContextBasedIdEnum['no-b2b']
    case MarketEnum.mediq_fi:
      return SiteContextBasedIdEnum['fi-b2b']
    case MarketEnum.mediq_se:
      return SiteContextBasedIdEnum['se-b2b']
    default:
      return SiteContextBasedIdEnum['dk-b2b']
  }
}
